<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Dividend Mandate</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/dividendMandate/add"> -->
          <button (click)="add()" class="btn btn-success pull-right"  [appHasPermission]="{'Url': '/register/dividendMandateList/edit?goveva=true&email=', 'method':'put', 'menu': 'dividendMandateList'}" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
    <!-- Date Filter  -->
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span> </div>
      <div class="card-block collapse" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <form>
              <div class="row">
                <div class="col-md-3">
                  <label> Name of Member
                  </label>
                  <div class="input-group">
                    <input type="text" class="form-control" [(ngModel)]="nameofMember" name="nameofMember">
                  </div>
                  <br>
                </div>
  
                <div class="col-md-3">
                  <!-- <label>Date of Mandate</label> -->
                  <br>
                  <div class="input-group" (click)="$event.stopPropagation()">
                    From:&nbsp;
                    <input id="dateOfMandate" class="form-control" [minDate]="futureFromDate"
                      style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfMandate" ngbDatepicker
                      #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfMandate">
                    <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                    </button>
                  </div>
                </div>
  
  
                <div class="col-md-3">
                
                  <br>
                  <div class="input-group" (click)="$event.stopPropagation()">
                    To:&nbsp;
                    <input id="dateOfMandateTo" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfMandateTo" ngbDatepicker
                    #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfMandateTo">
                  <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                  </div>
                </div>
  
                <div class="col-lg-2 col-lg-2 col-sm-2 ">
                  <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                  <br>
                  <div class="input-group">
                    <button type="button" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                      <i class="fa fa-search"></i>&nbsp;Search</button>
                    &nbsp;&nbsp;&nbsp;
                    <button type="button" class="btn btn-sm btn-default mb-2" (click)="clearAdvSearch()">
                      <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfMasterDirector" [dtTrigger]="dtTriggerMasterDirector"
                class="table table-hover compact cell-border nowrap stripe" id="dividendmandatelistTable"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <!-- <th>Sr. No.</th> -->
                    <th>Folio Number</th>
                    <th>Name of the member</th>
                    <th>Amount paid on <br>the Shares</th>
                    <th>Dividend Payable</th>
                    <th>Date of Payment</th>
                    <th style="display: none">Date of Payment</th>
                    <th>Date of Mandate</th>
                    <th style="display: none">Date of Mandate</th>
                    <th>Action
                      <!-- <span  [appHasPermission]="{'Url': '/register/dividendMandateList/edit?goveva=true&email=', 'method':'put', 'menu': 'dividendMandateList'}">Action</span> -->
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dividend of dividendMandateList">
                    <td>{{dividend.folioNumber}}</td>
                    <td>{{dividend.nameofMember}}</td>
                    <td>{{dividend.amountPaidontheShares}}</td>
                    <td>{{dividend.dividendPayable}}</td>
                    <td>
                      <span style="display: none">{{dividend.doPayment | date : "yMMdd"}}</span>
                      {{dividend.doPayment | date:"dd-MM-y"}}
                    </td>
                    <td style="display: none"> {{dividend.doPayment | date:"dd-MM-y"}} </td>
  
  
  
                    <td>
                      <span style="display: none">{{dividend.doMandate | date : "yMMdd"}}</span>
                      {{dividend.doMandate | date:"dd-MM-y"}}
                    </td>
                    <td style="display: none"> {{dividend.doMandate | date:"dd-MM-y"}} </td>
  
                    <td style='white-space: nowrap'>
                      <div class="input-group">
                        <button type="button" (click)="editdividendMandate(dividend._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/dividendMandateList/edit?goveva=true&email=', 'method':'put', 'menu': 'dividendMandateList'}">
                          <span class="fa fa-pencil"></span>
                        </button>
                        &nbsp;&nbsp;
                        <button type="button" class="btn-sm btn btn-danger" delete-meeting="5cee33d225242e023acfb2d4" [appHasPermission]="{'Url': '/register/dividendMandateList/edit?goveva=true&email=', 'method':'put', 'menu': 'dividendMandateList'}"
                          (click)="confirmDelete(dividend._id)">
                          <span class="icmn-bin"></span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
  
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete dividend mandate details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deletedividenddetail()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <app-alert></app-alert>